import { KnowledgeChannel } from './types';

/** Design tokens from export packages (style.css + design-tokens.json). */
export interface KnowledgeThemeTokens {
  accent: string;
  btnBg: string;
  btnText: string;
  link: string;
  linkHover: string;
  heading: string;
  text: string;
  maxWidth: string;
}

const helpTokens: KnowledgeThemeTokens = {
  accent: '#fec200',
  btnBg: '#fec200',
  btnText: '#ffffff',
  link: '#0066cc',
  linkHover: '#135f90',
  heading: '#111111',
  text: '#333333',
  maxWidth: '1140px',
};

const heroTokens: KnowledgeThemeTokens = {
  accent: '#46aedb',
  btnBg: '#46aedb',
  btnText: '#ffffff',
  link: '#0066cc',
  linkHover: '#135f90',
  heading: '#111111',
  text: '#333333',
  maxWidth: '1140px',
};

export function getKnowledgeTheme(channel: KnowledgeChannel): KnowledgeThemeTokens {
  return channel === 'help' ? helpTokens : heroTokens;
}
